<template>
    <el-dialog
        :title="$t('Image Tag')"
        append-to-body
        class="send-link-dialog"
        :close-on-click-modal="false"
        :visible.sync="show"
    >
        <div class="mb-10px">
            <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
            >
                {{ tag }}
            </el-tag>
            <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="mini"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput"
                >+ {{ $t('New Tag') }}</el-button
            >
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onAddTags" type="primary" size="small">{{ $t('Save') }}</el-button>
            <el-button type="text" @click="onCancel" size="small">{{ $t('Cancel') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { DEFAULT_ERROR_MESSAGE } from '@app/common/utils/constants';
import FileTag from '@/data/FileTag';

/* prop olarak tagleriyle berebar FileStorageItem alir. ve teg duzenlemesi yapar */
export default {
    name: 'imagetag',
    components: {},
    props: {
        value: null,
        fileStorage: null,
        visit_id: null,
        question: null,
    },
    data() {
        return {
            dynamicTags: [''],
            filteredTages: [],
            inputVisible: false,
            inputValue: '',
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    watch: {
        'fileStorage.tags': {
            // This will let Vue know to look inside the array
            deep: true,
            immediate: true,
            // We have to move our method to a handler field
            handler() {
                this.dynamicTags = this.fileStorage.tags
                    .filter((item) => item.record_state == 1)
                    .map((item) => item.tag);
            },
        },
    },
    methods: {
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
            const { inputValue } = this;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        onAddTags() {
            const dynamicTagsCopy = this.dynamicTags.slice();

            // butun record stateleri sifirla
            for (let index = 0; index < this.fileStorage.tags.length; index += 1) {
                const element = this.fileStorage.tags[index];
                element.record_state = 0;
            }

            const newTags = [];
            // sonra geri doldur
            for (let index = 0; index < dynamicTagsCopy.length; index += 1) {
                const element = dynamicTagsCopy[index];
                const fileTag = new FileTag({
                    file_storage_id: this.fileStorage.id,
                    tag: element,
                    record_state: 1,
                });
                newTags.push(fileTag);
            }

            this.fileStorage.tags = newTags;
            const self = this;

            this.fileStorage.saveorupdatetags({
                params: {},
                beforesend: () => {
                    self.loading = true;
                },
                complete: () => {
                    self.loading = false;
                },
                success: () => {
                    self.$notify.success({
                        title: self.$parent.$t('Success'),
                        message: self.$parent.$t('Record has been saved.'),
                    });
                    this.$emit('tags-saved', this.fileStorage.tags);
                    this.show = false;
                },
                failure: (op, response) => {
                    self.$notify.error({
                        title: self.$parent.$t('Error'),
                        message:
                            response && response.meta
                                ? response.meta.display_message
                                : self.$parent.$t(DEFAULT_ERROR_MESSAGE),
                    });
                },
            });
        },
        onCancel() {
            this.fileStorage.tags.forEach((tag) => {
                tag.reject();
            });

            this.show = false;
            this.$emit('cancel', this.fileStorage);
        },
    },
};
</script>

<style lang="scss">
.send-link-dialog {
    .el-tag + .el-tag {
        margin-left: 10px;
    }
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>
